import { Actions } from './constants';

export function adRequestInFlight(inFlight = false, token = null) {
  return {
    type: Actions.AD_REQUEST_IN_FLIGHT,
    data: {
      inFlight,
      token,
    },
  };
}

export function tryAdOpportunity(action, track) {
  return {
    type: Actions.AD_OPPORTUNITY,
    data: {
      action,
      track,
    },
  };
}

export function setExternalAdIdentifiers(ids) {
  return {
    type: Actions.SET_EXTERNAL_AD_IDENTIFIERS,
    data: {
      ids,
    },
  };
}

export function setPremiumAccessVideoStats(targetId, target) {
  return {
    type: Actions.SET_PA_VIDEO_STATS,
    data: {
      targetId,
      target,
    },
  };
}

export function logApsMM4ExposureEvent() {
  return {
    type: Actions.LOG_APS_MM4_EXPOSURE_EVENT,
  };
}

export function handleTile() {
  return {
    type: Actions.HANDLE_TILE,
  };
}

export function logUIDExposureEvent() {
  return {
    type: Actions.LOG_UID_EXPOSURE_EVENT,
  };
}
